module.exports = __webpack_public_path__ + "static/media/20_11_08_Gif_cas-clinique_BPCO_Doctor.406310b9.gif";